import React, { useEffect, useState } from 'react';
import ContainerLayout from '../../../../../layout/dashboard/container';
// import PageLayout from '../../../../../layout/dashboard/tableLayout';
import '../styles/index.css';
import { icons } from '../../../../../assets/icons';
import {
	colorToRgba,
	formatDateTime,
	// formatNumWithComma,
	getActionNamesByPolicyName,
	getCookie,
	removeSpace,
	// getCookie,
	returnInitial,
	setCookie,
	// symbol,
} from '../../../../../utils/helper/Helper';
import EmptyScreen from '../../../../../components/common/emptyScreen';
import { useDarkMode } from '../../../../../hooks/useDarkMode';

import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	BarElement,
	Title,
	Tooltip,
	Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import RootState from '../../../../../redux/types';
import { generateRandomColor } from '../../../../../utils/helper/color';
// import { getDashboardData } from '../../../../../redux/wallet';
import { bankboxAPI } from '../../../../../redux/bankbox';
import WithdrawalModal from '../modals/WithdrawalModal';
import DashboardLayout from '../../../../../layout/dashboard/dashboardLayout';
// import { getSettingsConfig } from '../../../../../redux/settings';
// import SettleMentAccountModal from '../../users/component/SettleMentAccountModal';
import ProccessSettleMentAccountModal from './ProccessSettlementModal';
import { useNavigate } from 'react-router-dom';
import SettleMentAccountPartnerModal from '../../settings/components/SettleAccountPartner';
import BadgeComponent from '../../../../../components/common/badge/BadgeComponent';
import { ALL_ROUTES } from '../../../../../routes/dashboard/overview/AllPathNames';
import {
	RavenBadge,
	RavenNumberFormat,
	RavenToolTip,
} from '@ravenpay/raven-bank-ui';
import {
	DashboardIcon,
	Sidemenwicons,
} from '../../../../../assets/icons/SidemenuIcons';

function BankBoxMainOverview() {
	const { profile } = useSelector((state: RootState) => state.settings);
	// const [showModal, ]
	const navigate = useNavigate();
	const [graphData, setGraphData] = React.useState<{
		index: number;
		content: string[];
	}>({
		index: 0,
		content: [],
	});
	const [theme, toggleTheme] = useDarkMode(localStorage.getItem('theme'));

	const [truety, setTruety] = React.useState({
		collection: false,
		transfer: false,
	});

	type showModalProp = {
		add_settle: boolean;
		settle: boolean;
		withdraw: boolean;
	};
	const [showModal, setShowModal] = React.useState<showModalProp>({
		withdraw: false,
		settle: false,
		add_settle: false,
	});

	const {
		dashboard_summary,
		loading,
		top_transacting,
		chart_data,
		banks,
		partner_settlement_info,
		account_change_requests,
	} = useSelector((state: RootState) => state.bankbox);
	// Get the current date
	const currentDate = new Date();

	// Create an array for the past 7 days
	const past7Days: string[] = [];
	for (let i = 0; i < 7; i++) {
		const date = new Date(currentDate.getTime() - i * 24 * 60 * 60 * 1000);
		past7Days.push(date.toISOString());
	}

	// Create an array for the past 30 days
	const past30Days: string[] = [];
	for (let i = 0; i < 30; i++) {
		const date = new Date(currentDate.getTime() - i * 24 * 60 * 60 * 1000);
		past30Days.push(date.toISOString());
	}

	function generatePastDays(lastDate: Date | string) {
		const newDays: string[] = [];
		const current = new Date(lastDate);
		if (lastDate) {
			for (let i = 0; i < 7; i++) {
				const date = new Date(current.getTime() - i * 24 * 60 * 60 * 1000);
				newDays.push(date.toISOString());
			}
		}

		return newDays;
	}

	ChartJS.register(
		CategoryScale,
		LinearScale,
		BarElement,
		Title,
		Tooltip,
		Legend
	);

	function handleGraphData(str?: string) {
		let i = graphData.index;

		if (str === 'prev') {
			if (i > 1) {
				i = i - 1;
			}
		} else {
			i = i + 1;
		}

		if (i === 1) {
			setGraphData({
				index: i,
				content: past7Days,
			});
		} else {
			setGraphData({
				index: i,
				content: generatePastDays(graphData.content[6]),
			});
		}
	}

	function isEmpty() {
		return truety.collection === true && truety.transfer === true;
	}

	useEffect(() => {
		if (past7Days) {
			setGraphData({
				index: 1,
				content: past7Days,
			});
		}
	}, []);

	function Graph() {
		const options: any = {
			plugins: {
				legend: {
					display: false,
					labels: {
						position: 'left',
						align: 'start',
						font: {
							size: 14,
							style: (ctx: any, options: any) => {
								// You can customize the logic here to determine the style dynamically
								return ctx.chart?.data?.datasets?.[options.datasetIndex]
									?.label === 'Collection'
									? 'italic'
									: 'normal';
							},
							color: 'black',
						},
					},
				},
			},
			responsive: true,
			scales: {
				x: {
					grid: {
						drawBorder: false,
						display: false,
					},
					ticks: {
						display: true,
					},
				},
				y: {
					ticks: {
						display: false,
					},
					border: { dash: [6, 6] }, // for the grid lines

					grid: {
						color: theme === 'dark' ? '#cccccc23' : '#E1E1E1', // for the grid lines
						tickColor: 'white', // for the tick mark
						tickBorderDash: [2, 3], // also for the tick, if long enough
						tickLength: 15, // just to see the dotted line
						tickWidth: 2.5,
						offset: true,
						drawTicks: false, // true is default
						drawOnChartArea: true, // true is default
					},

					beginAtZero: true,
				},
			},
		};

		const formattedDates = graphData.content.map(
			(dateString: string | number | Date, index: number) => {
				const date = new Date(dateString);
				if (graphData.index === 1) {
					if (index === 0) {
						return 'Today';
					} else if (index === 1) {
						return 'Yesterday';
					} else {
						return formatDateTime(date).split(',')[0];
					}
				} else {
					return formatDateTime(date).split(',')[0];
				}
			}
		);

		const labels = formattedDates;
		const collx =
			chart_data.length >= 1 &&
			chart_data?.slice(7 * graphData.index - 7, 7 * graphData.index);

		// //(collx);

		const data = {
			labels,
			datasets: [
				{
					label: 'BankBox Disbursed',
					data: labels?.map((chi: any, idx: string | number) => collx[idx]),
					backgroundColor:
						theme === 'dark'
							? colorToRgba(`#${profile?.partnerDetails?.color_code}`, 0.1)
							: colorToRgba(`#${profile?.partnerDetails?.color_code}`, 0.1),
					borderColor: colorToRgba(
						`#${profile?.partnerDetails?.color_code}`,
						0.8
					),
					borderWidth: 2,
					borderRadius: 10,
				},
			],
		};

		return (
			<Bar
				height={80}
				width={200}
				options={options}
				// ref={chartRef}
				data={data}
			/>
		);
	}

	const dispatch = useDispatch();
	const [refreshTable, setRefreshTable] = useState<boolean>(false);
	// const localToken = getCookie('token');
	const appid = getCookie('x-pos-key');
	const statusVal = profile?.partnerDetails?.status;
	React.useEffect(() => {
		// //(profile, '---------------testing--------------');
		// //(appid);
		if (appid && String(statusVal) === '1') {
			setCookie('x-pos-key', appid, 3000);
			// localStorage.setItem('x-p', appid);
			dispatch(bankboxAPI.getDashboardSummary({}));
			dispatch(bankboxAPI.getChartData({}));
			dispatch(bankboxAPI.getTopTransacting({}));
			// dispatch(bankboxAPI.getSettingsConfigBankbox({}));
			if (banks?.length < 1) {
				dispatch(bankboxAPI.getBankboxBanks({}));
			}
		}
	}, [refreshTable]);

	// useEffect(() => {
	// 	dispatch(getSettingsConfig());
	// 	// getSettingsConfig
	// }, []);

	const arrowIcon = (
		<svg
			className="img"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				// className="dull-bright-filter"
				d="M6 18L18 6M18 6H10M18 6V14"
				stroke={theme === 'light' ? `var(--primary-base-color)` : `#ffffff`}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	const abbreviateNum = 15;

	const addIcon = (
		<svg
			className="img"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 5V19M5 12H19"
				stroke={theme === 'light' ? `var(--primary-base-color)` : `#ffffff`}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	// const [noAccount, setNoAccount] = useState(true);

	if (
		!getActionNamesByPolicyName(
			profile?.rolePolicies?.policies,
			'overview'
		)?.includes('view_overview')
	) {
		return (
			// <DashboardLayout>
			<>
				<EmptyScreen
					loading={Object?.keys(profile)?.length < 1 ? true : false}
					title="Permission Denied"
					subTitle="You have no permission to access this page, Please contact admin or support."
				></EmptyScreen>
			</>
			// </DashboardLayout>
		);
	}

	return (
		<>
			{/* <DashboardLayout> */}
			<ContainerLayout
				pageTitle="BankBox"
				topRightContent={
					!loading && (
						<>
							{' '}
							{Object?.keys(partner_settlement_info)?.length < 1 &&
								getActionNamesByPolicyName(
									profile?.rolePolicies?.policies,
									'settlement'
								)?.includes('add_settlement_account') && (
									<div
										onClick={() => {
											setShowModal((prev) => {
												return { ...prev, add_settle: true };
											});
										}}
										className="white-black-bg process-settlement-btn border-theme"
									>
										<div className="icon-box">
											<figure className="img-box">{addIcon}</figure>
										</div>
										<div className="text">Add Settlement</div>
									</div>
								)}
							{Object?.keys(partner_settlement_info)?.length > 0 &&
								getActionNamesByPolicyName(
									profile?.rolePolicies?.policies,
									'settlement'
								)?.includes('process_settlement') && (
									<div
										onClick={() => {
											setShowModal((prev) => {
												return { ...prev, settle: true };
											});
										}}
										className="white-black-bg process-settlement-btn border-theme"
									>
										<div className="text">Process Settlement</div>
										<div className="icon-box">
											<figure className="img-box">{arrowIcon}</figure>
										</div>
									</div>
								)}
						</>
					)
				}
				pageMode
				style={{
					height: '100%',
					backgroundColor: loading ? 'white' : 'unset',
					borderRadius: loading ? '1rem' : 'unset',
				}}
				disableBack
				loading={loading}
				pageSubtitle="Manage BankBox devices on the platform"
			>
				<div
					// onClick={() => {
					// 	// //(partner_settlement_info);
					// 	// //(dashboard_summary);
					// 	// //(profile);
					// }}
					className="bank-box-overview"
				>
					<div className="bank-box-overview__stats-wrapper">
						<div className="bank-box-overview__stats-wrapper--stats grey-bg-two">
							<div className="top">
								<figure className="img-box grey-bg-two">
									{DashboardIcon?.balanceIcon}
								</figure>
								<button
									style={{ cursor: 'pointer', visibility: 'hidden' }}
									onClick={() => {
										setShowModal((prev) => {
											return { ...prev, withdraw: true };
										});
									}}
									className="button"
								>
									<p>Withdraw</p>
								</button>
							</div>
							<div className="bottom">
								<p>Collection Balance</p>
								<h6
									className={
										removeSpace(
											String(
												RavenNumberFormat(dashboard_summary?.collectionBalance)
											)
										)?.length >= abbreviateNum
											? 'tooltip-hover-wrap'
											: ''
									}
								>
									{RavenNumberFormat(dashboard_summary?.collectionBalance, {
										numberAbbreviate:
											removeSpace(
												String(
													RavenNumberFormat(
														dashboard_summary?.collectionBalance
													)
												)
											)?.length >= abbreviateNum,
									})}
									{removeSpace(
										String(
											RavenNumberFormat(dashboard_summary?.collectionBalance)
										)
									)?.length >= abbreviateNum ? (
										<RavenToolTip
											color={`deep-green-light`}
											position="top-center"
											text={RavenNumberFormat(
												dashboard_summary?.collectionBalance
											)}
										/>
									) : (
										''
									)}
								</h6>
							</div>
						</div>

						<div className="bank-box-overview__stats-wrapper--stats grey-bg-two">
							<div className="top">
								<figure className="img-box grey-bg-two">
									{DashboardIcon?.bankreqIcon}
								</figure>
							</div>
							<div className="bottom">
								<p>Merchants Balance</p>
								<h6
									className={
										removeSpace(
											String(
												RavenNumberFormat(dashboard_summary?.merchantBalance)
											)
										)?.length >= abbreviateNum
											? 'tooltip-hover-wrap'
											: ''
									}
								>
									{RavenNumberFormat(dashboard_summary?.merchantBalance, {
										numberAbbreviate:
											removeSpace(
												String(
													RavenNumberFormat(dashboard_summary?.merchantBalance)
												)
											)?.length >= abbreviateNum,
									})}
									{removeSpace(
										String(
											RavenNumberFormat(dashboard_summary?.merchantBalance)
										)
									)?.length >= abbreviateNum ? (
										<RavenToolTip
											color={`deep-green-light`}
											position="top-center"
											text={RavenNumberFormat(
												dashboard_summary?.merchantBalance
											)}
										/>
									) : (
										''
									)}
								</h6>
							</div>
						</div>

						<div
							onClick={() => {
								if (
									Number(
										RavenNumberFormat(dashboard_summary?.totalPendingRequest, {
											hideSymbol: true,
											hideDecimal: true,
											convertToNumber: true,
										})
									) > 0
								) {
									navigate('/dashboard-terminals');
								}
							}}
							className="bank-box-overview__stats-wrapper--stats grey-bg-two"
							style={{
								cursor:
									Number(
										RavenNumberFormat(dashboard_summary?.totalPendingRequest, {
											hideSymbol: true,
											hideDecimal: true,
											convertToNumber: true,
										})
									) > 0
										? 'pointer'
										: 'default',
							}}
						>
							<div className="top">
								<figure className="img-box grey-bg-two">
									{DashboardIcon?.bankdisburedIcon}
								</figure>
								{Number(
									RavenNumberFormat(dashboard_summary?.totalPendingRequest, {
										hideSymbol: true,
										hideDecimal: true,
									})
								) > 0 && (
									<div className="badge-pending-box">
										<RavenBadge
											type="yellow"
											text={`Pending request${
												Number(
													RavenNumberFormat(
														dashboard_summary?.totalPendingRequest,
														{ hideSymbol: true, hideDecimal: true }
													)
												) > 1
													? 's'
													: ''
											}: ( ${RavenNumberFormat(
												dashboard_summary?.totalPendingRequest,
												{ hideSymbol: true, hideDecimal: true }
											)} )`}
										/>
									</div>
								)}
							</div>
							<div className="bottom">
								<p>Total BankBox Disbursed</p>
								<h6>
									{' '}
									{RavenNumberFormat(dashboard_summary?.totalBankBoxDisbursed, {
										hideSymbol: true,
										hideDecimal: true,
									})}
								</h6>
							</div>
						</div>

						<div
							style={{
								cursor:
									Number(
										RavenNumberFormat(dashboard_summary?.totalUsers, {
											hideSymbol: true,
											hideDecimal: true,
											convertToNumber: true,
										})
									) > 0
										? 'pointer'
										: 'default',
							}}
							onClick={() => {
								if (
									Number(
										RavenNumberFormat(dashboard_summary?.totalUsers, {
											hideSymbol: true,
											hideDecimal: true,
											convertToNumber: true,
										})
									) > 0
								) {
									navigate(ALL_ROUTES?.BANKBOX_USER);
								}
							}}
							className="bank-box-overview__stats-wrapper--stats grey-bg-two"
						>
							<div className="top">
								<figure className="img-box grey-bg-two">
									{DashboardIcon?.usersIcon}
								</figure>
							</div>
							<div className="bottom">
								<p>Total Users</p>
								<h6>
									{' '}
									{RavenNumberFormat(dashboard_summary?.totalUsers, {
										hideSymbol: true,
										hideDecimal: true,
									})}{' '}
								</h6>
							</div>
						</div>
					</div>

					<div className="bank-box-overview__bottom-contain">
						<div className="charts__graph grey-bg-two">
							<div className="graph__top">
								<div className="top__title ">
									<p>BankBox collections</p>
									<div className="title__graph-indicator">
										<span>
											<p></p>
											<p>Amount of BankBox collections</p>
										</span>
									</div>
								</div>
								<div onClick={isEmpty} className="top__filter">
									<p>
										{graphData.index === 1
											? 'This Week'
											: formatDateTime(graphData.content[6])?.split(',')[0] +
											  ' - ' +
											  formatDateTime(graphData.content[0])?.split(',')[0]}
									</p>
									<span>
										<figure
											// style={{
											// 	cursor: graphData.index === 1 ? 'no-drop' : '',
											// }}
											onClick={() => {
												handleGraphData('next');
											}}
										>
											{icons.chevron_left}
										</figure>
										<figure
											className="next_cursor"
											onClick={() => {
												graphData.index > 1 && handleGraphData('prev');
												// handleGraphData('next');
											}}
											style={{
												cursor: graphData.index === 1 ? 'no-drop' : '',
											}}
										>
											{icons.chevron_right}
										</figure>
									</span>
								</div>
							</div>

							{loading ||
							// (truety.collection === true && truety.transfer === true) ||
							graphData.index === 0 ? (
								<EmptyScreen noMascot loading={loading} />
							) : (
								<div className="graph__main  ">
									{' '}
									<Graph />{' '}
								</div>
							)}
						</div>

						<div className="gen-wrap">
							<div className="bank-box-overview__stats-wrapper--stats grey-bg-two">
								<div className="flex_box">
									<div className="top">
										<figure className="grey-bg-two">
											{DashboardIcon?.bankswitchIcon}
										</figure>
									</div>
									<div>
										<RavenBadge
											style={{ backgroundColor: '#fff6ed' }}
											children={
												<>
													<div className="bagde_item">
														<figure>{icons.flagbagde}</figure>
														<p className="impo_text">IMPORTANT</p>
													</div>
												</>
											}
										/>
									</div>
								</div>
								<div className="bottom_wrap">
									<div className="bottom">
										<p>Bank Switch Request</p>
										<h6>{dashboard_summary?.bankSwitchRequests}</h6>
									</div>
									{dashboard_summary?.bankSwitchRequests > 0 && (
										<div className="badge-wrap-index">
											<RavenBadge
												onClick={() => {
													navigate(ALL_ROUTES?.SETTLEMENT_HISTORY);
												}}
												type={`default`}
											>
												<span className="black-white-color">View Requests</span>
												<figure className="img-box">{icons.badgeIcon}</figure>
											</RavenBadge>
										</div>
									)}
								</div>
							</div>
							<div className="top-transacting grey-bg-two">
								{top_transacting.length === 0 ? (
									<div className="empty_all_bb">
										<figure>{icons.top_transacting_mascot}</figure>
										<h6>No Data for this Metrics</h6>
										<p>
											Top 5 Users with most transactions show up here as time
											goes on
										</p>
									</div>
								) : (
									<>
										<div className="top-transacting__title">
											<figure>{icons.top_transacting}</figure>
											<h6>Top 5 Transacting Users</h6>
										</div>
										<div className="top-transacting__users grey-bg-two">
											{top_transacting.map((chi, idx) => {
												return (
													<div key={idx} className="top-users">
														<span
															style={{
																backgroundColor: generateRandomColor('#e9f5ff'),
															}}
														>
															<p>
																{returnInitial(
																	`${chi?.lname || ''} ${chi?.fname || ''}`
																)}
															</p>
														</span>
														<div className="name-box">
															<p className="name">
																{' '}
																{`${chi?.lname || ''} ${chi?.fname || ''}`}
															</p>
															<p className="email"> {chi?.email}</p>
														</div>
													</div>
												);
											})}
										</div>
									</>
								)}
							</div>
						</div>
					</div>
				</div>
			</ContainerLayout>
			{/* </DashboardLayout> */}

			{/* withdraw modal show start */}
			<WithdrawalModal
				onClose={() => {
					setShowModal((prev) => {
						return { ...prev, withdraw: false };
					});
				}}
				visible={showModal.withdraw}
			/>
			{/* withdraw modal show end */}
			<ProccessSettleMentAccountModal
				onClose={() => {
					setShowModal((prev) => {
						return { ...prev, settle: false };
					});
				}}
				visible={showModal.settle}
				onFinish={() => {
					setRefreshTable(!refreshTable);
				}}
			/>
			<SettleMentAccountPartnerModal
				onClose={() => {
					setShowModal((prev) => {
						return { ...prev, add_settle: false };
					});
				}}
				visible={showModal?.add_settle}
				value={profile}
			/>
		</>
	);
}

export default BankBoxMainOverview;
